import CallUs from 'components/Content/CustomerService/CallUs/CallUs';

export default CallUs;
